import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import './App.css';
import axios from "axios";
import React from 'react';
import { BrowserRouter } from "react-router-dom";

export default class App extends React.Component {
  state = {
    sections: []
  }
  
  componentDidMount() {
    const apiToken= process.env.REACT_APP_IARENAS_TOKEN;
    const getSectionsAPI='https://rg24xdvhj6.execute-api.us-east-1.amazonaws.com/default/iarenas-getSections'
    axios.post(
      getSectionsAPI,
      {'type':'section' },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiToken
        }
        }).then(res => {
          const sections = res.data;
          this.setState({ sections });
          
      })
  }


  render() {
    return (
    <Container fluid className="App">
      <Row >
        <Col cols="12" className='blankMenuRow'/>
      </Row>
    {
      this.state.sections.map(section =>  
      <Row key={section.section} className="text-center">
        <Col xl="2"></Col>
        <Col cols="12" lg="12" xl="8" >
          <div className='Image'>
            <Image fluid src={section.photo} />
            <div className={section.labelPosition }> { section.section } </div>
          </div>
        </Col>
        <Col xl="2"></Col>
      </Row>
    )}
      <Row>
        <Col cols="12" className='blankMenuRow d-block d-lg-none'/>
      </Row>
    </Container>
    );
  }
}
